// extracted by mini-css-extract-plugin
export default {"guid":"GuidTip_guid__VLXYw","img":"GuidTip_img__Ts4tx"};